import {t} from 'i18next'

import type {BookingField} from '@progyny/types/calcom'

/**
 * Hardcoded booking fields configuration per program slug.
 * These fields will be passed to Cal.com and rendered in the booking form.
 *
 * Supported field types:
 * - 'select': Dropdown with predefined options
 * - 'text': Single-line text input
 * - 'textarea': Multi-line text input
 * - 'number': Numeric input
 * - 'email': Email input
 * - 'phone': Phone number input
 */
export const PROGRAM_BOOKING_FIELDS: Record<string, BookingField[]> = {
  'pregnancy-ask-a-midwife': [
    {
      name: 'discussion_topic',
      type: 'select',
      label: 'I would like to talk about',
      required: true,
      editable: 'user',
      options: [
        {label: 'Birth planning', value: 'birth_planning'},
        {label: 'Postpartum recovery', value: 'postpartum_recovery'},
        {label: 'Feeding support', value: 'feeding_support'},
      ],
    },
  ],
  'postpartum-ask-a-midwife': [
    {
      name: 'discussion_topic',
      type: 'select',
      label: 'I would like to talk about',
      required: true,
      editable: 'user',
      options: [
        {label: 'Birth planning', value: 'birth_planning'},
        {label: 'Postpartum recovery', value: 'postpartum_recovery'},
        {label: 'Feeding support', value: 'feeding_support'},
      ],
    },
  ],
}

/**
 * Get booking fields for a specific program with translations applied.
 */
export function getBookingFieldsForProgram(
  programSlug: string
): BookingField[] {
  const fields = PROGRAM_BOOKING_FIELDS[programSlug] || []

  // Translate labels using i18next
  // The member-portal uses the English text as the key
  return fields.map((field) => ({
    ...field,
    label: t(field.label),
    placeholder: field.placeholder ? t(field.placeholder) : undefined,
    options: field.options?.map((opt) => ({
      ...opt,
      label: t(opt.label),
    })),
    // Add sources to indicate this field comes from the embed
    sources: [
      {
        id: 'embed',
        type: 'user',
        label: 'Embed',
      },
    ],
  }))
}
